import classNames from 'classnames';
import React from 'react';
import { baseXUnit, color, fontSize, spacing } from '../../../styles/theme';
import { t } from '../../../utils/i18n';
import DivButton from '../../a11y/DivButton';
import FadeAnimation from '../../animations/FadeAnimation';
import Button from '../../elements/Button';
import ButtonText from '../../elements/ButtonText';
import H from '../../elements/H';
import CardContainer from '../CardContainer';
import FlexDiv from '../FlexDiv';
import Spacing from '../Spacing';

interface EmailCardProps {
  onSendClicked: (email: string) => void;
}

const EmailCard: React.FunctionComponent<EmailCardProps> = ({
  onSendClicked
}) => {
  const [email, setEmail] = React.useState<string>();
  const [emailValid, setEmailValid] = React.useState<boolean>(true);
  const [success, setSuccess] = React.useState<boolean>(false);
  return (
    <CardContainer data-testid="email-card">
      <Spacing top={2} right={2} bottom={2} left={2}>
        <FlexDiv flexDirection="column">
          <ButtonText variant="secondary" color="gray">
            {t('Lähetä sähköpostiosoitteesi')}
          </ButtonText>
          <Spacing top={1.5}>
            <input
              type="email"
              data-cy="email-card-input"
              placeholder={t('Sähköpostiosoitteesi')}
              className={classNames('email-input', { invalid: !emailValid })}
              value={email}
              onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEmailValid(true);
                setEmail(event.target.value);
              }}
            />
          </Spacing>
          {success && (
            <Spacing top={[3.75, 3.75, 3.75, 2.75]} left="auto">
              <FadeAnimation>
                <H styling="h3">{t('Kiitos!')}</H>
              </FadeAnimation>
            </Spacing>
          )}
          {!success && (
            <Spacing top={1.5} left="auto">
              <DivButton
                onClick={() => {
                  if (email) {
                    onSendClicked(email);
                    setSuccess(true);
                  } else {
                    setEmailValid(false);
                  }
                }}
                data-cy="email-card-send-button"
              >
                <Button>
                  <ButtonText variant="primary" color="white">
                    {t('Lähetä')}
                  </ButtonText>
                </Button>
              </DivButton>
            </Spacing>
          )}
        </FlexDiv>
      </Spacing>
      {/*language=CSS*/}
      <style jsx global>{`
        .email-input {
          width: 100%;
          padding: ${baseXUnit(2)} ${baseXUnit(1.5)} ${baseXUnit(1.5)}
            ${baseXUnit(1.5)};
          border-radius: ${spacing.one};
          display: block;
          border: 1px solid ${color.light};
          font-size: ${fontSize.px14};
        }
        .email-input.invalid {
          border-color: ${color.pool};
        }
      `}</style>
    </CardContainer>
  );
};

export default EmailCard;
